import { useTournament, useTournamentUpdate } from "../TournamentContext";
import SectionTitle from "../../../components/SectionTitle";
import CreateBracket from "./components/CreateBracket";
import BracketLevel from "./components/BracketLevel";
import { bracketLevels } from "./constants";
import deleteBracket from "../../../functions/deleteSection/deleteBracket";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../firebase/config";
import BracketTimes from "./components/BracketTimes";
import generateGameNumbers from "../../../functions/generateGameNumbers";
import Hyperlink from "./components/Hyperlink";

const Bracket = () => {
  const { tournament, teams, games, tournamentId, isUserOrganizer } =
    useTournament();
  const { bracket, schedule, isBracketPublic, bracketType, bracketTimes } =
    tournament;
  const { updateTournament } = useTournamentUpdate();

  const handleDeleteBracket = () => {
    deleteBracket(tournamentId);
  };

  const togglePublicity = async () => {
    const tournamentRef = doc(firestore, "tournaments", tournamentId);

    updateTournament("isBracketPublic", !isBracketPublic);

    try {
      await updateDoc(tournamentRef, { isBracketPublic: !isBracketPublic });
    } catch (error) {
      alert("Something went wrong updating the visibility!");
      console.log(error);
    }
  };

  if (!teams || !schedule || (!isBracketPublic && !isUserOrganizer)) return;

  const gameNumbers = generateGameNumbers(bracket, bracketType, games);

  return (
    <section className="w-full flex flex-col mb-6">
      <SectionTitle
        title={"Bracket"}
        onDelete={bracket ? handleDeleteBracket : null}
        isPublic={isBracketPublic}
        handlePublicity={togglePublicity}
      />

      {bracket && games ? (
        <>
          {isUserOrganizer && bracketTimes && (
            <div className="w-full flex justify-center gap-4 mb-4 ">
              <BracketTimes
                numberOfDays={1}
                bracketStartTimes={bracketTimes.startTimes}
                bracketGameLength={bracketTimes.gameLength}
                bracketInterval={bracketTimes.interval}
                bracketNumberOfCourts={bracketTimes.numberOfCourts}
              />

              <Hyperlink
                bracket={bracket}
                games={games}
                teams={teams}
                tournamentId={tournamentId}
              />
            </div>
          )}

          <div className="overflow-x-auto">
            {bracketLevels.map((bracketLevel) => {
              const rounds = bracket[bracketLevel] || null;

              if (!rounds) {
                return null;
              }

              return (
                <BracketLevel
                  key={bracketLevel}
                  bracketType={bracketType}
                  bracketLevel={bracketLevel}
                  rounds={rounds}
                  gameNumbers={gameNumbers}
                />
              );
            })}
          </div>
        </>
      ) : (
        <>{isUserOrganizer && <CreateBracket tournamentId={tournamentId} />}</>
      )}
    </section>
  );
};

export default Bracket;
